import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { KYMW1506Model } from './kymw1506.model';
import { RegistCwsIconDataVo } from './vo/regist-cws-icon-data.model';
import { RegistCwsIconData } from './api-services/regist-cws-icon-data-service';
import { GetMarkGroupListService } from '../kymw1500/api-services/get-mark-group-list.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { FileUploadService, FileAccept } from '../../../commons/kymw02/file-upload/file-upload.service';

/**
 * アイコン登録画面を管理するクラス
 *
 * @export KYMW1506Component
 * @class KYMW1506Component
 */
@Component({
  selector: 'app-kymw1506',
  templateUrl: 'kymw1506.component.html',
  styleUrls: ['kymw1506.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1506Component extends PlessViewHelperSub implements OnInit {
  @ViewChild('txt_StartOrderCode', { static: true }) txt_StartOrderCode: OrderCodeTextInputComponent;
  @ViewChild('txt_EndOrderCode', { static: true }) txt_EndOrderCode: OrderCodeTextInputComponent;
  @ViewChild('btn_ImageNormal', { static: true }) btn_ImageNormal: ElementRef;

  kymw1506Model: KYMW1506Model = new KYMW1506Model();

  /**
   *Creates an instance of KYMW1506Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1506Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private getMarkGroupListService: GetMarkGroupListService,
    private registCwsIconData: RegistCwsIconData,
    private elementRef: ElementRef,
    private fileUploadService: FileUploadService,
    ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1506Component
   */
  public ngOnInit() {
    this.componentName = 'KYMW1506';

    // マークグループ一覧取得
    this.getMarkGroupListService.execute((data: any) => {
      if (PlessViewUtilsSub.isEmptyArray(data)) {
        // マークグループコードが取得できませんでした
        this.dialogService.openAlertGetMessage('E0127', null, () => {
          this.closeFunction();
        });
      }
      this.kymw1506Model.updateMarkGroupList(data);
    });
  }

  /**
   * コード指定 チェックボックス 値変更
   *
   * @memberof KYMW1506Component
   */
  public eventIconCodeEntry_CLICKHandler() {
    if (!this.kymw1506Model.iconCodeEntry) {
      this.kymw1506Model.iconCode = '';
    }
  }

  /**
   * 指定なし（開始） チェックボックス 値変更
   *
   * @memberof KYMW1506Component
   */
  public eventNotDesignateStart_CLICKHandler() {
    if (this.kymw1506Model.notDesignateStart) {
      this.kymw1506Model.startOrderCode = '';
      this.kymw1506Model.startOrderCodeEnabled = false;
    } else {
      this.kymw1506Model.startOrderCodeEnabled = true;
    }
  }

  /**
   * 指定なし（終了） チェックボックス 値変更
   *
   * @memberof KYMW1506Component
   */
  public eventNotDesignateEnd_CLICKHandler() {
    if (this.kymw1506Model.notDesignateEnd) {
      this.kymw1506Model.endOrderCode = '';
      this.kymw1506Model.endOrderCodeEnabled = false;
    } else {
      this.kymw1506Model.endOrderCodeEnabled = true;
    }
  }


  /**
   * グループコード 値変更
   * 
   * @memberof KYMW1506Component
   */
  public eventIconGroup_CHANGEHandler() {
    if (this.kymw1506Model.iconGroup === 'blankVal') this.kymw1506Model.iconGroup = '';
  }

  /**
   * アイコンファイル(通常) 選択 ボタン 押下
   */
  public eventImageNormal_ClickHandler(): void {
    this.selectFile('Normal');
  }

  /**
   * アイコンファイル(大) 選択 ボタン 押下
   */
  public eventImageBig_ClickHandler(): void {
    this.selectFile('Big');
  }

  /**
   * アイコンファイル(モバイル) 選択 ボタン 押下
   */
  public eventImageMobile_ClickHandler(): void {
    this.selectFile('Mobile');
  }

  /**
   * アイコンファイル選択共通処理
   */
  private selectFile(imageType: string) {
    this.fileUploadService.upload((selectedFiles: File[]) => {
      const extension = PlessViewUtilsSub.getExtension(selectedFiles[0].name);
      if (extension !== 'jpg') {
        this.dialogService.openAlertGetMessage('E0220');
        return;
      }
      if (imageType === 'Normal') {
        this.kymw1506Model.imageFileNormal = selectedFiles[0];
        this.kymw1506Model.imageFileNameNormal = selectedFiles[0].name;
        this.kymw1506Model.imageFileUrlNormal = window.URL.createObjectURL(selectedFiles[0]);
      } else if (imageType === 'Big') {
        this.kymw1506Model.imageFileBig = selectedFiles[0];
        this.kymw1506Model.imageFileNameBig = selectedFiles[0].name;
        this.kymw1506Model.imageFileUrlBig = window.URL.createObjectURL(selectedFiles[0]);
      } else if (imageType === 'Mobile') {
        this.kymw1506Model.imageFileMobile = selectedFiles[0];
        this.kymw1506Model.imageFileNameMobile = selectedFiles[0].name;
        this.kymw1506Model.imageFileUrlMobile = window.URL.createObjectURL(selectedFiles[0]);
      }
    }, [FileAccept.JPG], false);
  }

  /**
   * 追加 ボタン 押下
   *
   * @memberof KYMW1506Component
   */
  public eventAdd_CLICKHandler() {
    if (this.kymw1506Model.iconCodeEntry && this.kymw1506Model.iconCode === '') {
      this.dialogService.openAlertGetMessage('E0110', ['アイコンコード']);
      return;
    }
    if (this.kymw1506Model.iconName === '') {
      this.dialogService.openAlertGetMessage('E0110', ['アイコン名']);
      return;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw1506Model.iconGroup) || this.kymw1506Model.iconGroup === 'blankVal') {
      this.dialogService.openAlertGetMessage('E0103', ['グループ']);
      return;
    }
    if (this.kymw1506Model.iconDiv === '') {
      this.dialogService.openAlertGetMessage('E0103', ['アイコン区分']);
      return;
    }
    if (this.kymw1506Model.arrangeDiv === '') {
      this.dialogService.openAlertGetMessage('E0103', ['配置区分']);
      return;
    }
    if (this.kymw1506Model.iconExplain === '') {
      this.dialogService.openAlertGetMessage('E0110', ['アイコン説明']);
      return;
    }
    if (!this.kymw1506Model.notDesignateStart && this.kymw1506Model.startOrderCode === '') {
      this.dialogService.openAlertGetMessage('E0110', ['使用開始受注コード']);
      return;
    }
    if (!this.kymw1506Model.notDesignateEnd && this.kymw1506Model.endOrderCode === '') {
      this.dialogService.openAlertGetMessage('E0110', ['使用終了受注コード']);
      return;
    }
    if (!this.kymw1506Model.notDesignateStart && !this.txt_StartOrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('E0122', ['使用開始受注コード']);
      return;
    }
    if (!this.kymw1506Model.notDesignateEnd && !this.txt_EndOrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('E0122', ['使用終了受注コード']);
      return;
    }
    if (!this.kymw1506Model.notDesignateStart && !this.kymw1506Model.notDesignateEnd) {
      if (Number(this.kymw1506Model.startOrderCode) > Number(this.kymw1506Model.endOrderCode)) {
        this.dialogService.openAlertGetMessage('E0123', ['受注コード']);
        return;
      }
    }
    if (this.kymw1506Model.imageFileNameNormal === '') {
      this.dialogService.openAlertGetMessage('E0103', ['アイコンファイル(通常)']);
      return;
    }
    if (this.kymw1506Model.imageFileNameBig === '') {
      this.dialogService.openAlertGetMessage('E0103', ['アイコンファイル(大)']);
      return;
    }
    if (this.kymw1506Model.imageFileNameMobile === '') {
      this.dialogService.openAlertGetMessage('E0103', ['アイコンファイル(モバイル)']);
      return;
    }

    // 入力した情報でECアイコン情報を登録しますか？
    this.dialogService.openAlertGetMessage('Q0104', ['ECアイコン情報'], (closeEvent: any) => {
      if (closeEvent === PlessAlert.Yes) {
        const fileList: File[] = [
          this.kymw1506Model.imageFileNormal,
          this.kymw1506Model.imageFileBig,
          this.kymw1506Model.imageFileMobile,
        ];

        this.registCwsIconData.execute(new RegistCwsIconDataVo(
          this.kymw1506Model.iconCode,
          this.kymw1506Model.iconName,
          this.kymw1506Model.iconGroup,
          this.kymw1506Model.iconDiv,
          this.kymw1506Model.arrangeDiv,
          this.kymw1506Model.iconExplain,
          this.kymw1506Model.getOutputDiv(),
          this.kymw1506Model.startOrderCode,
          this.kymw1506Model.endOrderCode,
          this.kymw1506Model.iconAlternativeText
        ), fileList, () => {this.updateInitDisplay();});
      }
    });
  }

  /**
   * 初期表示状態に更新する
   *
   * @memberof KYMW1506Component
   */
  public updateInitDisplay() {
    this.kymw1506Model.iconCode = '';
    this.kymw1506Model.iconCodeEntry = false;
    this.kymw1506Model.iconName = '';
    this.kymw1506Model.iconGroup = '';
    this.kymw1506Model.iconDiv = '';
    this.kymw1506Model.arrangeDiv = '';
    this.kymw1506Model.iconExplain = '';
    this.kymw1506Model.category = false;
    this.kymw1506Model.weekly = false;
    this.kymw1506Model.daily = false;
    this.kymw1506Model.logistics = false;
    this.kymw1506Model.order = false;
    this.kymw1506Model.startOrderCode = this.kymw1506Model.startOrderCodeInit;
    this.kymw1506Model.notDesignateStart = this.kymw1506Model.startOrderCode === '';
    this.kymw1506Model.startOrderCodeEnabled = !this.kymw1506Model.notDesignateStart;
    this.kymw1506Model.endOrderCode = this.kymw1506Model.endOrderCodeInit;
    this.kymw1506Model.notDesignateEnd = this.kymw1506Model.endOrderCode === '';
    this.kymw1506Model.endOrderCodeEnabled = !this.kymw1506Model.notDesignateEnd;
    this.kymw1506Model.imageFileNormal = null;
    this.kymw1506Model.imageFileNameNormal = '';
    this.kymw1506Model.imageFileUrlNormal = '';
    this.kymw1506Model.imageFileBig = null;
    this.kymw1506Model.imageFileNameBig = '';
    this.kymw1506Model.imageFileUrlBig = '';
    this.kymw1506Model.imageFileMobile = null;
    this.kymw1506Model.imageFileNameMobile = '';
    this.kymw1506Model.imageFileUrlMobile = '';
    this.kymw1506Model.iconAlternativeText = '';
  }
}
